import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { ChallengeApp } from './challenge/ChallengeApp.tsx';
import './index.css';

// The challenge pages (/reto/…) and the chat share the bundle; a link between them reloads
const isChallenge = location.pathname === '/reto' || location.pathname.startsWith('/reto/');

createRoot(document.getElementById('root')!).render(
  <StrictMode>{isChallenge ? <ChallengeApp /> : <App />}</StrictMode>,
);
